import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import {ClientesList} from 'components/clientes/list/clientes.list';
import {ClientesCreate} from 'components/clientes/create/clientes.create';
import {ClientesEdit} from 'components/clientes/edit/clientes.edit';
import {MainContext} from "contexts/main.context";

const basePath = '/clientes';

export class Clientes extends Component {
    componentDidMount() {
        this.context.setHeaderTitle('Clientes');
    }

    render() {
        return (
            <div className='niquel-clientes'>
                <Switch>
                    {/*<Route path={`${basePath}/:cliente/view/:cobranza`} component={CobranzasView}/>*/}
                    <Route path={`${basePath}/create`} component={ClientesCreate}/>
                    <Route path={`${basePath}/edit/:cliente`} component={ClientesEdit}/>
                    {/*<Route path={`${basePath}/:cliente`} component={CobranzasList}/>*/}
                    <Route path={`${basePath}`} component={ClientesList}/>
                </Switch>
            </div>
        )
    }
}

Clientes.contextType = MainContext;
